export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "scripts/app.Message.worker.0820ec4294e14edf5e48.worker.js");
}
